// REACT
import React, { Component } from 'react';

// STYLING
import styled from 'styled-components';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import IconButton from 'components/Button/IconButton';
import Button from 'components/Primatives/Button';
import H3 from 'components/Primatives/H3';
import FlexColumn from 'components/Primatives/FlexColumn';

import StyledTimeBlockComponent from './StyledTimeBlockComponent';
import { constants } from '../../../constants';
import StyledFormComponent from './StyledFormComponent';

const moment = require('moment');

const StyledCard = styled(FlexColumn)`
    justify-content: start;
    align-content: center;
    align-items: center;
    background-color: white;
    color: #3fa9b4;
    border-radius: 5px;
    margin: 8px;
    box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);
    padding: 15px;
    flex: 1;
`;

const StyledCardTitle = styled.div`
    text-align: center;
    font-size: 16px;
`;

const StyledCardComponent = ({
    cardName,
    title,
    timeBlocks,
    showDeleteConfirmationDialog,
    deleteType,
    addEditAvailability,
    grabEndTime,
    grabStartTime,
    saveNewException,
    exceptionCardData,
    getDialogContent,
    toggleExceptionCard
}) => {            
        console.log(exceptionCardData, 'saveNewException present?')
        
        let addModalForm =  <StyledFormComponent
                                grabEndTime={grabEndTime}
                                grabStartTime={grabStartTime}
                                addEditAvailability={addEditAvailability}
                                formName={cardName}
                                formMessage="Add Availability"
                            />
        let editModalForm = <StyledFormComponent
                                grabEndTime={grabEndTime}
                                grabStartTime={grabStartTime}
                                addEditAvailability={addEditAvailability}
                                formName={cardName}
                                formMessage="Edit Availability"
                            />
        return (
            <StyledCard id='StyledCardComponent' className={cardName}>
                    <StyledCardTitle>{title}</StyledCardTitle>
                    {typeof timeBlocks[0] === 'object' ?
                        timeBlocks.map((timeBlock, index) => {
                            return <StyledTimeBlockComponent
                                        key={index}
                                        index={index}
                                        timeBlock={timeBlock}
                                        showDeleteConfirmationDialog={showDeleteConfirmationDialog}
                                        deleteType={deleteType}
                                        editModalForm={editModalForm}
                                        getDialogContent={getDialogContent}
                                        formName={cardName}
                                    />
                        }) :
                        <H3 style={{textAlign: 'center'}}>No Availability</H3>
                    }
                    <div style={{
                            display:"flex",
                            flexDirection:"column"
                    }}>
                        <Button 
                            buttonColorAlt
                            onClick={() => getDialogContent(addModalForm, `Add Availability for ${title}`, timeBlocks)} 
                            style={{ 
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                fontSize: '1.2em',
                                padding: '7px 15px'
                            }}
                        >
                            <FontAwesomeIcon 
                                icon={['far', 'plus-square']}
                                style={{ display: "block" , marginRight: 10 }}
                                size={"2x"}
                                color={constants.color.light}
                            />
                            <H3 light style={{margin: 1}}>
                                Add Availability
                            </H3>
                        </Button>
                        
                        {exceptionCardData &&
                            <div style={{
                                display:"flex",
                                flexDirection:"row"
                            }}>
                                <button 
                                    onClick={exceptionCardData.saveNewException}
                                    style={{
                                        flex: 1,
                                        alignItems: 'center', 
                                        justifyContent: 'flex-start',
                                        backgroundColor: "orange",
                                        color: "white",
                                        borderRadius: "5px",
                                        borderStyle: "none",
                                        padding: "3%",
                                        width: '100%',
                                        display: 'block',
                                        height: '40px',
                                        marginTop: 10,
                                        marginRight: 5,
                                        fontSize: 16,
                                    }}
                                >
                                    Save
                                </button>
                                <button 
                                    onClick={toggleExceptionCard}
                                    style={{
                                        flex: 1,
                                        alignItems: 'center', 
                                        justifyContent: 'flex-start',
                                        backgroundColor: "grey",
                                        color: "white",
                                        borderRadius: "5px",
                                        borderStyle: "none",
                                        padding: "3%",
                                        width: '100%',
                                        display: 'block',
                                        height: '40px',
                                        marginTop: 10,
                                        marginLeft: 5,
                                        fontSize: 16,
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        }
                    </div>
            </StyledCard>
        );
};

export default StyledCardComponent;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/components/StyledCardComponent.jsx